<script>
    import { language } from './stores';
    import Calendar from './Calendar.svelte';

    async function fetchData() {
        let response = await fetch('/api');
        return response.json();
    }
</script>

<style>
.headerbar {
    position: fixed;
/* 	background-image: url("/images/justiina.png");
	background-position: center;
	background-size: 30em; */
    background-color: black;
    height: 4em;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

.logos {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3em;
    flex-grow: 0;
}

.logos > img {
    height: 70%;
}

.space {
    flex: 1;
}

.language-links {
    display: flex;
    justify-content: end;
}

.language {
    color: white;
    font-size: 1.1em;
    margin-right: 0.7em;
}

main {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 4em;
    max-width: 500px;
    margin: 0 auto;
}

h1 {
    margin: 0;
    margin-bottom: 0.5em;
}

.box-container {
    margin-top: 1em;
    box-sizing: border-box;
    background-image: url("/images/justiina.png");
	background-position: center;
	background-size: 5em;
    width: 100%;
}

.box {
    box-sizing: border-box;
    background-color: black;
    padding: 0.2em;
}

@media (max-width: 499px) {
    .box-container {
        padding: 1em 0;
    }
}

@media (min-width: 500px) {

    .box-container {
        border-radius: 2em;
        padding: 1em;
    }
    .box {
        border: 0.5em solid black;
        border-radius: 1em;
    }
}
</style>

<div class="headerbar">
    <div class="space">&nbsp;</div>
    <div class="logos"><img src="/images/anplaceholder.png"><img src="/images/inkplaceholder.png"></div>
    <div class="space language-links">
        <a class="language" on:click={() => language.set("sv")} href="">SV</a>
        <a class="language" on:click={() => language.set("en")} href="">EN</a>
    </div>
</div>
<main>
{#await fetchData()}
loading
{:then data}
<div class="box-container"><div class="box"><h1>{{en:"Schedule",sv:"Schema"}[$language]}</h1><Calendar data={data.calendar} /></div></div>
{:catch error}
{error}
{/await}
</main>